import { useState, useEffect, useCallback } from 'react';
import { hasUserAgreedToTerms, getTermsAgreementStatus } from 'src/utils/termsAgreement';

export const useTermsAgreement = () => {
  const [hasAgreed, setHasAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const checkAgreementStatus = useCallback(() => {
    const status = hasUserAgreedToTerms();
    setHasAgreed(status);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    // Check terms agreement status on mount
    checkAgreementStatus();

    // Listen for storage changes (in case terms are agreed to in another tab)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'terms_agreement_status' || e.key === 'terms_agreement_timestamp') {
        checkAgreementStatus();
      }
    };

    // Also listen for custom events (for same-tab updates)
    const handleCustomStorageChange = () => {
      checkAgreementStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('termsAgreementChanged', handleCustomStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('termsAgreementChanged', handleCustomStorageChange);
    };
  }, [checkAgreementStatus]);

  const refreshAgreementStatus = useCallback(() => {
    checkAgreementStatus();
  }, [checkAgreementStatus]);

  return {
    hasAgreed,
    isLoading,
    refreshAgreementStatus,
    agreementDetails: getTermsAgreementStatus()
  };
};
